import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserRole } from '../../../features/users/users.model';
import { RolesService } from '../../../features/roles/roles.service';

@Component({
  selector: 'app-role-select',
  standalone: false,
  templateUrl: './role-select.component.html',
  styleUrl: './role-select.component.scss'
})
export class RoleSelectComponent implements OnInit {
  @Input() value: string | null = null;
  @Input() hasError: boolean = false;
  @Output() valueChange = new EventEmitter<{ id: string; label: string }>();

  roles: UserRole[] = [];
  isLoading: boolean = false;

  constructor(private rolesService: RolesService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.rolesService.getRoles().subscribe({
      next: (res) => {
        // Map database options
        this.roles = res.data.map(r => ({
          id: r.id,
          name: r.name
        }));
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Failed to load roles:', err);
        this.isLoading = false;
      }
    });
  }

  onSelectChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const selectedId = select.value;
    const selectedRole = this.roles.find(r => r.id === selectedId);

    if (selectedRole) {
      this.value = selectedId;
      this.valueChange.emit({ id: selectedRole.id, label: selectedRole.name });
    } else {
      this.value = null;
      this.valueChange.emit(null as any);
    }
  }
}
